<template >
  <div class="loading" v-if="loading" id="loading">
    <div class="loading__spinner">
        <div
          class="line"
          v-for="(line, index) in lines"
          :key="index"
          :style="`animation-delay: ${line * 0.12}s;`"
        >
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    lines: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    rgbValues: {
      start: [0, 0, 0],
      stop: [0, 0, 0]
    },
    gradients: [
      { start: [62, 35, 255], stop: [60, 255, 60] },
      { start: [255, 35, 98], stop: [45, 175, 230] },
      { start: [214, 41, 118], stop: [254, 218, 117] },
      { start: [255, 0, 255], stop: [255, 128, 0] },
      { start: [0, 153, 204], stop: [239, 50, 217] },
      { start: [77, 160, 176], stop: [211, 157, 56] }
    ],
    currentIndex: 0,
    rgbSteps: {
      start: [0, 0, 0],
      stop: [0, 0, 0]
    },
    nextIndex: 1,
    stepsCount: 0,
    steps_total: Math.round(3 * 60),
    color1: '',
    color2: '',
    divStyle: '',
    prefixes: ['-webkit-', '-moz-', '-o-', '-ms-', '']
  }),
  mounted () {
    let $div = document.getElementById('loading')
    if ($div && $div.length) {
      this.divStyle = $div.style
      this.calcSteps()
      window.requestAnimationFrame(this.updateGradient)
    }
  },
  methods: {
    updateGradient () {
      for (let key in this.rgbValues) {
        if (this.rgbValues.hasOwnProperty(key)) {
          for (let i = 0; i < 3; i++) {
            this.rgbValues[key][i] += this.rgbSteps[key][i]
          }
        }
      }

      let tColor1 = 'rgb(' + (this.rgbValues.start[0] | 0) + ',' + (this.rgbValues.start[1] | 0) + ',' + (this.rgbValues.start[2] | 0) + ')'
      let tColor2 = 'rgb(' + (this.rgbValues.stop[0] | 0) + ',' + (this.rgbValues.stop[1] | 0) + ',' + (this.rgbValues.stop[2] | 0) + ')'

      if (tColor1 !== this.color1 || tColor2 !== this.color2) {
        this.color1 = tColor1
        this.color2 = tColor2
        this.divStyle.backgroundImage = '-webkit-gradient(linear, left bottom, right top, from(' + this.color1 + '), to(' + this.color2 + '))'
        for (var i = 0; i < 4; i++) {
          this.divStyle.backgroundImage = this.prefixes[i] + 'linear-gradient(45deg, ' + this.color1 + ', ' + this.color2 + ')'
        }
      }

      this.stepsCount++

      if (this.stepsCount > this.steps_total) {
        this.stepsCount = 0
        this.currentIndex = this.setNext(this.currentIndex)
        this.nextIndex = this.setNext(this.nextIndex)
        this.calcSteps()
      }

      if (this.divStyle.backgroundImage.indexOf('gradient') !== -1) {
        window.requestAnimationFrame(this.updateGradient)
      }
    },
    calcSteps () {
      for (var key in this.rgbValues) {
        if (this.rgbValues.hasOwnProperty(key)) {
          for (var i = 0; i < 3; i++) {
            this.rgbValues[key][i] = this.gradients[this.currentIndex][key][i]
            this.rgbSteps[key][i] = this.calcStepSize(this.gradients[this.nextIndex][key][i], this.rgbValues[key][i])
          }
        }
      }
    },
    calcStepSize (a, b) {
      return (a - b) / this.steps_total
    },
    setNext (num) {
      return (num + 1 < this.gradients.length) ? num + 1 : 0
    }
  }
}
</script>
